export default __webpack_public_path__ + "static/media/metaIconGray.a8b4ac01.svg";